import { render, staticRenderFns } from "./PopupAddAgent.vue?vue&type=template&id=5584c85d&scoped=true"
import script from "./PopupAddAgent.vue?vue&type=script&lang=js"
export * from "./PopupAddAgent.vue?vue&type=script&lang=js"
import style0 from "./PopupAddAgent.vue?vue&type=style&index=0&id=5584c85d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5584c85d",
  null
  
)

export default component.exports